import { render, staticRenderFns } from "./DashboardDetailPatrolNg.vue?vue&type=template&id=3bb556c9&scoped=true&"
import script from "./DashboardDetailPatrolNg.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailPatrolNg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb556c9",
  null
  
)

export default component.exports